import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'app/store';
import EmptyStatePlaceholder from 'components/shared/EmptyStatePlaceholder';
import InvitationLinksTable from 'components/members/InvitationLinksTable';
import Preloader from 'components/shared/Preloader';
import { getInvitations } from 'features/invitationLinksList/invitationLinksListActions';
import {
  filterInvitationsSelector,
  isLoadingInvitationsSelector,
  listInvitationsSelector,
} from 'features/invitationLinksList/invitationLinksListSlice';

const InvitationLinks = () => {
  const invitations = useSelector(listInvitationsSelector);
  const isLoading = useSelector(isLoadingInvitationsSelector);
  const dispatch = useAppDispatch();
  const invitationssPageFilter = useSelector(filterInvitationsSelector);

  useEffect(() => {
    dispatch(getInvitations(invitationssPageFilter));
  }, []);

  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          {invitations.length > 0 ? (
            <InvitationLinksTable />
          ) : (
            <EmptyStatePlaceholder>No invitation links have been created</EmptyStatePlaceholder>
          )}
        </>
      )}
    </>
  );
};

export default InvitationLinks;
